module.exports = __webpack_public_path__ + "img/4.cb05e1e1.jpg";